import {go} from "./stage-transitions";
import imgWelcomeStarIcon from '../images/welcome-star-icon.svg';
import imgWelcomeQuestionIcon from '../images/welcome-question-icon.svg';
import imgWelcomeTrophyIcon from '../images/welcome-trophy-icon.svg';

let _onPlay = null;
let currentPanel = null;

function getScreen() {
    return document.querySelector('.js-screen[data-screen="welcome"]');
}

function iconForPanel(name) {
    if (name === 'how-to-play') return imgWelcomeQuestionIcon;
    if (name === 'scoring')     return imgWelcomeTrophyIcon;
    return imgWelcomeStarIcon;
}

function showPanel(name) {
    const screen = getScreen();
    if (!screen) return;
    screen.querySelectorAll('.s-game-welcome__panel').forEach((p) => {
        p.hidden = p.dataset.panel !== name;
    });
    const iconEl = screen.querySelector('.js-gw-icon');
    if (iconEl) iconEl.src = iconForPanel(name);
    currentPanel = name;
    screen.scrollTop = 0;
}

function exitModal() {
    return getScreen()?.querySelector('[data-exit-modal]');
}

function showExitModal() {
    const m = exitModal();
    if (!m) return;
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
}

function hideExitModal() {
    const m = exitModal();
    if (!m) return;
    m.hidden = true;
    m.setAttribute('aria-hidden', 'true');
}

function buildSlideshow(container, slides) {
    let current = 0;

    const slidesHtml = slides.map((slide, i) => {
        const heroHtml = slide.image
            ? `<img src="${slide.image}" alt="" class="s-gw-slides__hero" loading="lazy">`
            : '';
        const imagesHtml = slide.images && slide.images.length > 0
            ? `<div class="s-gw-slides__sprites">${
                slide.images.map(url => `<img src="${url}" alt="" class="s-gw-slides__sprite-img" loading="lazy">`).join('')
            }</div>`
            : '';
        return `<div class="s-gw-slides__slide" data-slide-idx="${i}">
            <span class="s-gw-slides__heading">${slide.heading}</span>
            <div class="s-gw-slides__body">${slide.body}</div>
            ${heroHtml}
            ${imagesHtml}
        </div>`;
    }).join('');

    const dotsHtml = slides.map((_, i) =>
        `<button type="button" class="s-gw-slides__dot${i === 0 ? ' is-active' : ''}" data-idx="${i}" aria-label="Slajd ${i + 1}"></button>`
    ).join('');

    container.innerHTML = `<div class="s-gw-slides">
        <div class="s-gw-slides__viewport"><div class="s-gw-slides__track">${slidesHtml}</div></div>
        <div class="s-gw-slides__dots">${dotsHtml}</div>
    </div>`;

    const track = container.querySelector('.s-gw-slides__track');
    const dotsEl = container.querySelector('.s-gw-slides__dots');

    function goTo(idx) {
        current = Math.max(0, Math.min(slides.length - 1, idx));
        track.style.transform = `translateX(${-current * 100}%)`;
        dotsEl.querySelectorAll('.s-gw-slides__dot').forEach((dot, i) => {
            dot.classList.toggle('is-active', i === current);
        });
    }

    dotsEl.addEventListener('click', (e) => {
        const dot = e.target.closest('.s-gw-slides__dot');
        if (dot) goTo(parseInt(dot.dataset.idx, 10));
    });

    let startX = 0, startY = 0;
    container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    }, { passive: true });
    container.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
            goTo(dx < 0 ? current + 1 : current - 1);
        }
    }, { passive: true });
}

export function fillWelcomeScreen(config, onPlay) {
    const screen = getScreen();
    if (!screen) return;

    _onPlay = onPlay;

    screen.querySelector('.js-gw-title').textContent = config.title;
    screen.querySelector('.js-gw-desc').innerHTML = config.description;
    screen.querySelector('.js-gw-htp-title').textContent = config.howToPlay.heading;

    const htpDesc = screen.querySelector('.js-gw-htp-desc');
    if (config.howToPlay.slides) {
        buildSlideshow(htpDesc, config.howToPlay.slides);
    } else {
        htpDesc.innerHTML = config.howToPlay.body;
    }

    screen.querySelector('.js-gw-pkt-title').textContent = config.scoring.heading;
    screen.querySelector('.js-gw-pkt-desc').innerHTML = config.scoring.body;

    hideExitModal();
    showPanel('main');
}

document.addEventListener('click', (e) => {
    if (e.target.closest('.js-gw-btn-htp')) {
        showPanel('how-to-play');
        return;
    }
    if (e.target.closest('.js-gw-btn-pkt')) {
        showPanel('scoring');
        return;
    }
    if (e.target.closest('.js-gw-panel-close')) {
        if (currentPanel !== 'main') {
            showPanel('main');
            return;
        }
        showExitModal();
        return;
    }
    if (e.target.closest('.js-welcome-back')) {
        if (!getScreen() || getScreen().getAttribute('aria-hidden') === 'true') return;
        showExitModal();
        return;
    }
    if (e.target.closest('.js-gw-exit-no')) {
        hideExitModal();
        return;
    }
    if (e.target.closest('.js-gw-exit-yes')) {
        hideExitModal();
        go('days');
        return;
    }
    if (e.target.closest('.js-gw-play')) {
        // One-shot: szybki double-tap na „Graj" nie może odpalić /start dwa razy —
        // drugi start trafiałby w bramkę jednej próby i zwracał false „already_completed".
        const cb = _onPlay;
        _onPlay = null;
        if (cb) cb();
        return;
    }
});
